import { Box, Button, Stack, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import Logo from "./../../assets/images/Logo.svg"
import LoginFormNumber from "./Scenes/LoginInfoStage";
import LoginFormNumberValidation from "./Scenes/LoginNumberPassStage";
import LoginFormSubmitDetails from "./Scenes/LoginRegisterStage";
import { useNavigate } from "react-router-dom";
import LoginFormUsername from "./Scenes/LoginUserPassStage";
import WBButton from "components/input/WBButton";


const SplashButton = styled(WBButton)(
    ({ theme }) => `
        width: 100%;
        height: 48px;
        color: ${theme.palette.text.primary} !important;
        font-weight: bold;
    `
)

const LoginMainContainer = styled(Stack)(
    () => `
        justify-content: space-between;
        align-items: center;
        height: 100% !important;
    `
)

const LoginSceneContainer = styled(Stack)(
    () => `
        min-height: calc(100% - 250px);
        width: 100%;
    `
)

export default function LoginMain({ stage, setStage }) {

    // Stage == 1 Login
    // Stage == 2 Validation
    // Stage == 3 Submit User Detail
    // Stage == 4 Password login

    const [loginData, setLoginData] = useState("")
    const [code, setCode] = useState("")
    const [loading, setLoading] = useState(false)

    const handleLoginSystem = () => {

        //Stage handling for submitting forms
        switch(stage) {
            case 1 :
                document.getElementById("SubmitNumber").click()
            break;
            case 2 :
                document.getElementById("SubmitNumberCode").click()
            break;
            case 3 :
                document.getElementById("SubmitUserDetail").click()
            break;
            case 4 :
                document.getElementById("SubmitUserPass").click()
            break;
        }
    } 

    return (
        <LoginMainContainer>
            <img style={{width: "160px", height: '45px'}} src={Logo} alt="لوگو پاکسرشت هوم" />
            <LoginSceneContainer>
                { 
                    stage == 1 && <LoginFormNumber setLoading={setLoading} setLoginData={setLoginData} setStage={setStage} loginData={loginData} />
                }
                {
                    stage == 2 && <LoginFormNumberValidation setLoading={setLoading} code={code} loginData={loginData} setStage={setStage} setCode={setCode} />
                }
                {
                    stage == 3 && <LoginFormSubmitDetails setLoading={setLoading} code={code} loginData={loginData} />
                }
                {
                    stage == 4 && <LoginFormUsername setLoading={setLoading} setStage={setStage} loginData={loginData} setCode={setCode} />
                }
            </LoginSceneContainer>    
            <SplashButton 
                handleClick={handleLoginSystem} 
                labelText="ورود" 
                loading={loading} 
                variant="contained"  
            />
        </LoginMainContainer>
    )
}
